import { useState } from 'react'
import { SignatureContrat } from '../Types/Class/SignatureContrat'

export interface UseCreditsManagementReturn {
    credits: SignatureContrat[]
    setCredits: (credits: SignatureContrat[]) => void
    deletedContrats: number[]
    newCredit: { CreditsAchetes: number; NoCmd: string }
    setNewCredit: (credit: { CreditsAchetes: number; NoCmd: string }) => void
    editingCreditId: number | null
    setEditingCreditId: (id: number | null) => void
    handleAddCredit: () => void
    handleUpdateCredit: (index: number) => void
    handleDeleteCredit: (index: number) => void
    getTotalCredits: () => { achetes: number; consommes: number; restants: number }
    resetCredits: () => void
    loadCredits: (data: SignatureContrat[]) => void
}

export function useCreditsManagement(
    setHasChanges: (value: boolean) => void
): UseCreditsManagementReturn {
    const [credits, setCredits] = useState<SignatureContrat[]>([])
    const [deletedContrats, setDeletedContrats] = useState<number[]>([])
    const [newCredit, setNewCredit] = useState({ CreditsAchetes: 500, NoCmd: '' })
    const [editingCreditId, setEditingCreditId] = useState<number | null>(null)

    const handleAddCredit = () => {
        if (!newCredit.NoCmd.trim()) {
            alert('Le numéro de commande est obligatoire')
            return
        }

        const credit = new SignatureContrat({
            CreditsAchetes: newCredit.CreditsAchetes,
            NoCmd: newCredit.NoCmd,
            CreditsConsommes: 0,
        })

        setCredits([...credits, credit])
        setNewCredit({ CreditsAchetes: 500, NoCmd: '' })
        setHasChanges(true)
    }

    const handleUpdateCredit = (index: number) => {
        setEditingCreditId(null)
        setHasChanges(true)
    }

    const handleDeleteCredit = (index: number) => {
        // Trouver le contrat à supprimer
        const contratToRemove = credits[index]

        // Si le contrat a un ID (existe en BDD), l'ajouter à la liste des suppressions
        if (contratToRemove?.IDSignatureParametreContrat) {
            setDeletedContrats([...deletedContrats, contratToRemove.IDSignatureParametreContrat])
        }

        // Retirer le contrat de la liste
        setCredits(credits.filter((_, i) => i !== index))
        setHasChanges(true)
    }

    const getTotalCredits = () => {
        const achetes = credits.reduce((sum, c) => sum + c.CreditsAchetes, 0)
        const consommes = credits.reduce((sum, c) => sum + (c.CreditsConsommes || 0), 0)
        return {
            achetes,
            consommes,
            restants: achetes - consommes
        }
    }

    const resetCredits = () => {
        setCredits([])
        setDeletedContrats([])
        setNewCredit({ CreditsAchetes: 500, NoCmd: '' })
        setEditingCreditId(null)
    }

    const loadCredits = (data: SignatureContrat[]) => {
        setCredits(data || [])
        setDeletedContrats([])
    }

    return {
        credits,
        setCredits,
        deletedContrats,
        newCredit,
        setNewCredit,
        editingCreditId,
        setEditingCreditId,
        handleAddCredit,
        handleUpdateCredit,
        handleDeleteCredit,
        getTotalCredits,
        resetCredits,
        loadCredits,
    }
}
